Ext.define('SA.VectorMapExportCropPreviewMap', {
    alias: 'widget.vector-map-export-crop-preview-map',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-vector-map-export-crop-preview-map',

    initComponent() {
        var modelState = this.model.getState();

        this.items = [
            {
                xtype: 'vector-map-export-thematic-map',
                geoJsonSourcesData: SA.VectorMapThematicMapGeoJsonSourcesData.get(modelState, {enableServerSideClustering: false}),
                layersProperties: SA.VectorMapThematicMapLayersProperties.get(modelState),
                maxExtent: modelState.maxExtent,
                style: SA.VectorMapConstants.getThematicMapStyle(),
                styleBaseUrls: SA.VectorMapConstants.getThematicMapStyleBaseUrls(),
                tileSourcesUrls: SA.VectorMapThematicMapTileSourcesUrls.get(modelState)
            }
        ];

        this.callParent();

        this.map = this.down('vector-map-export-thematic-map');
    },

    initEvents() {
        this.callParent();

        this.map.onHttpError(this.onMapHttpError, this);
        this.map.onLoadingChange(() => this.setLoading(this.map.isLoading() ? 'Loading preview…' : false));
    },

    extentToPageBox(extent) {
        var mapExtent = this.extent,
            mapLeft = mapExtent.getLeft(),
            mapTop = mapExtent.getTop(),
            mapWidth = mapExtent.getWidth(),
            mapHeight = mapExtent.getHeight(),

            left = extent.getLeft(),
            top = extent.getTop(),
            width = extent.getWidth(),
            height = extent.getHeight(),

            size = this.getTargetMapSize(),
            imgHeight = size.height,
            imgWidth = size.width,
            xy = this.map.getXY(),

            horizontalScale = imgWidth / mapWidth,
            verticalScale = imgHeight / mapHeight;

        return {
            height: height * verticalScale,
            width: width * horizontalScale,

            x: xy[0] + (left - mapLeft) * horizontalScale,
            y: xy[1] + (mapTop - top) * verticalScale
        };
    },

    getTargetMapSize() {
        return SA.restrictSizeByRatio({
            height: this.getHeight(),
            width: this.getWidth()
        }, this.extent.getAspectRatio(), true);
    },

    onMapHttpError({exceptionClass}) {
        if (exceptionClass.endsWith('TooManyPointsException')) {
            this.map.setGeoJsonSourcesData(SA.VectorMapThematicMapGeoJsonSourcesData.get(this.model.getState(), {enableServerSideClustering: true}));
        }
    },

    onResize() {
        var extent = SA.VectorMapExtent.fromXYBounds(this.extent.getBounds());

        this.callParent(arguments);

        this.map.setParams({extent, ...this.getTargetMapSize()});
    },

    pageBoxToExtent(pageBox) {
        var mapExtent = this.extent,
            mapLeft = mapExtent.getLeft(),
            mapTop = mapExtent.getTop(),
            mapWidth = mapExtent.getWidth(),
            mapHeight = mapExtent.getHeight(),

            x = pageBox.x,
            y = pageBox.y,
            height = pageBox.height,
            width = pageBox.width,

            size = this.getTargetMapSize(),
            imgHeight = size.height,
            imgWidth = size.width,
            xy = this.map.getXY(),

            horizontalScale = mapWidth / imgWidth,
            verticalScale = mapHeight / imgHeight,

            left = mapLeft + (x - xy[0]) * horizontalScale,
            top = mapTop + (xy[1] - y) * verticalScale;

        return SA.model.map.Extent.fromBounds([
            left,
            top - height * verticalScale,
            left + width * horizontalScale,
            top
        ]);
    }
});